<template>
    <div class="case-page page-padding">
        <div class="top-image-form">
            <h1>
                {{ $t('f_top_image_r2') }}
            </h1>
        </div>

        <div ref="formBlock" class="left-right-wrap">
            <div class="left">
                <claim-step
                    v-if="step < 5"
                    :current-step="step"
                    :step-count="4"
                    :step-names="[$t('f_r2_stepname_1'), $t('f_r2_stepname_2'), $t('f_r2_stepname_3'), $t('f_r2_stepname_4')]" />
                <r2s1flight v-if="step === 1" />
                <r2s2travelers v-if="step === 2" />
                <r2s3PhotoID v-if="passport_needed && step === 3" />
                <r2s4expenses v-if="step === 4" />
                <r2s5thank v-if="step === 5" />
            </div>

            <div class="right">
                <right-part-cases
                    :total_clients="$props.total_clients"
                    :average_saved="$props.average_saved"
                    :total_compensation="$props.total_compensation"
                    :reviews="$props.reviews"
                    :score="$props.score" />
            </div>
        </div>
    </div>
</template>

<script>
  import {mapFields} from 'vuex-map-fields'
  import ClaimStep from "@components/common/ClaimStep"
  import R2s1flight from "@components/round2/R2s1flight"
  import R2s2travelers from "@components/round2/R2s2travelers"
  import R2s3PhotoID from "@components/round2/R2s3PhotoID"
  import R2s4expenses from "@components/round2/R2s4expenses"
  import R2s5thank from "@components/round2/R2s5thank"
  import RightPartCases from "@components/common/RightPartCases"

  export default {
    components: {
      // ClaimStep: () => import("@components/common/ClaimStep"),
      // R2s1flight: () => import("@components/round2/R2s1flight"),
      // R2s2travelers: () => import("@components/round2/R2s2travelers"),
      // R2s3PhotoID: () => import("@components/round2/R2s3PhotoID"),
      // R2s4expenses: () => import("@components/round2/R2s4expenses"),
      // R2s5thank: () => import("@components/round2/R2s5thank"),
      // RightPartCases: () => import("@components/common/RightPartCases")
      ClaimStep,
      R2s1flight,
      R2s2travelers,
      R2s3PhotoID,
      R2s4expenses,
      R2s5thank,
      RightPartCases
    },
    props: ['translations', 'currencies', 'countries', 'back_locale','total_compensation', 'total_clients', 'average_saved', 'reviews', 'score'],
    computed: {
      ...mapFields([
        'round2.step',
        'round2.complaint.passport_needed',
        'round2.complaint.people'
      ])
    },
    watch: {
      step: function () {
        this.scrollToFormTop()
      }
    },
    created(){
      // this.$store.commit('round2/updateField', {path: 'step', value: 1})

      // set locale
      this.$store.commit('updateField', {path: 'locale', value: this.back_locale || 'en'})
      // get auth
      let auth_key = window.location.href.split('authorizations/').pop().replace("/", "")
      this.$store.dispatch('round2/getAuthorization', {auth_key: auth_key}).then((message) => {
        console.log(message)
      }).catch((message) => {
        console.error(message)
      })
      // translations
      let { locale, message } = this.translations
      this.$i18n.setLocaleMessage(locale, message)
      this.$i18n.locale = locale
      // countries
      this.$store.commit('round1/updateField', {
        path: 'countriesCodes', 
        value: this.countries
      })
      // currencies
      this.$store.commit('round2/updateField', {
        path: 'currenciesMapper',
        value: this.currencies
      })
    },
    mounted(){
      setTimeout(() => {
        this.scrollToFormTop() 
      }, 300)
    },
    methods: {
      scrollToFormTop(){
        let top_position = this.$device.mobile() ? 0 : this.$refs.formBlock?.offsetTop
        window.scrollTo({top: top_position, behavior: 'smooth'})
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .case-page {
    overflow: hidden;
    padding-top: 25px;
    position: relative;
    padding-bottom: 30px;

    html.tablet &, html.desktop & {
      padding-top: 0;
      min-width: 768px;
      box-sizing: border-box;
      overflow: hidden;
      padding-right: 0;
      padding-bottom: 0;
    }

    h2, h3 {
      font-weight: normal;
    }

    .title {
      font-size: 22px;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
    }

    .yes-no-wrap {
      margin-top: 30px;
      justify-content: space-around;

      > div {
        margin: 0;

        > label {
          font-size: 16px;
          line-height: 28px;
        }
      }
    }
  }
</style>
